export const getOldLocation = (oldUrl, websites) => {
  const oldUrlObject = new URL(oldUrl);
  const oldWebsite = websites.find((x) => x.domain === oldUrlObject.hostname);
  return {
    website: {
      href: oldWebsite.$$meta.permalink,
    },
    path: oldUrl.split(oldUrlObject.hostname)[1],
  };
};

export const replacePathSpecialCharacters = (value) => {
  return value
    .replace(/,/g, '')
    .replace(/:/g, '')
    .replace(/!/g, '')
    .replace(/\./g, '')
    .replace(/\?/g, '')
    .replace(/\(/g, '')
    .replace(/\)/g, '')
    .replace(/-/g, '')
    .replace(/'/g, '')
    .replace(/\+/g, '')
    .replace(/–/g, '')
    .replace(/\//g, '-')
    .replace(/…/g, '')
    .replace(/&amp;/g, '')
    .replace(/#/g, '')
    .replace(/‘/g, '')
    .replace(/’/g, '')
    .replace(/<br>/g, '')
    .replace(/@/g, '')
    .replace(/\[/g, '')
    .replace(/\]/g, '')
    .replace(/\$/g, '')
    .replace(/\*/g, '')
    .replace(/=/g, '')
    .replace(/&quot;/g, '')
    .replace(/&lt;/g, '')
    .replace(/&gt;/g, '')
    .replace(/%/g, '')
    .replace(/{/g, '')
    .replace(/}/g, '')
    .replace(/\|/g, '')
    .replace(/\\/g, '')
    .replace(/\^/g, '')
    .replace(/`/g, '')
    .replace(/;/g, '') // remove semicolon after &quot; &lt; etcs
    .trim()
    .replace(/\s+/g, '-')
    .replace(/--/g, '-');
};
